import { render, staticRenderFns } from "./OptionListItem.vue?vue&type=template&id=67e00b64&scoped=true&"
import script from "./OptionListItem.vue?vue&type=script&lang=js&"
export * from "./OptionListItem.vue?vue&type=script&lang=js&"
import style0 from "./OptionListItem.vue?vue&type=style&index=0&id=67e00b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e00b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VItem } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VHover,VItem})
